import { render, staticRenderFns } from "./AsignacionMantenimiento.vue?vue&type=template&id=f56311be&"
import script from "./AsignacionMantenimiento.vue?vue&type=script&lang=js&"
export * from "./AsignacionMantenimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports